
export const getSnackbarMsgs
    = (store) =>
    store.Snackbar.snackbar;
